import React, { useEffect, useState } from 'react';
import { ChevronUp } from 'lucide-react';

/**
 * Componente global de la landing:
 *  - Barra de progreso dorada en la parte superior que refleja el scroll.
 *  - Botón flotante "volver arriba" que aparece tras ~45% de scroll.
 */
const ScrollProgress: React.FC = () => {
  const [progress, setProgress] = useState(0);
  const [showTopBtn, setShowTopBtn] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      const doc = document.documentElement;
      const max = doc.scrollHeight - window.innerHeight;
      const ratio = max > 0 ? Math.min(1, Math.max(0, window.scrollY / max)) : 0;
      setProgress(ratio);
      setShowTopBtn(ratio > 0.45);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    return () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
    };
  }, []);

  const scrollToTop = () =>
    window.scrollTo({ top: 0, behavior: 'smooth' });

  return (
    <>
      <div
        className="landing-scroll-progress"
        style={{ transform: `scaleX(${progress})` }}
        aria-hidden="true"
      />
      <button
        type="button"
        onClick={scrollToTop}
        aria-label="Volver arriba"
        className={`landing-back-to-top${showTopBtn ? ' visible' : ''}`}
      >
        <ChevronUp size={22} />
      </button>
    </>
  );
};

export default ScrollProgress;
